import { render, staticRenderFns } from "./DetailHistoryBroadcast.vue?vue&type=template&id=b6ef977c&"
import script from "./DetailHistoryBroadcast.vue?vue&type=script&lang=js&"
export * from "./DetailHistoryBroadcast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports